/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskSeverityEnum } from './RiskSeverityEnum';
import {
    RiskSeverityEnumFromJSON,
    RiskSeverityEnumFromJSONTyped,
    RiskSeverityEnumToJSON,
    RiskSeverityEnumToJSONTyped,
} from './RiskSeverityEnum';
import type { RiskStatusEnum } from './RiskStatusEnum';
import {
    RiskStatusEnumFromJSON,
    RiskStatusEnumFromJSONTyped,
    RiskStatusEnumToJSON,
    RiskStatusEnumToJSONTyped,
} from './RiskStatusEnum';

/**
 * Serializer for Risk model with team context
 * @export
 * @interface Risk
 */
export interface Risk {
    /**
     * 
     * @type {number}
     * @memberof Risk
     */
    readonly id: number;
    /**
     * Brief title describing the risk
     * @type {string}
     * @memberof Risk
     */
    title: string;
    /**
     * Detailed description of the risk
     * @type {string}
     * @memberof Risk
     */
    description: string;
    /**
     * Level of risk severity
     * 
     * * `LOW` - Low
     * * `MEDIUM` - Medium
     * * `HIGH` - High
     * * `CRITICAL` - Critical
     * @type {RiskSeverityEnum}
     * @memberof Risk
     */
    severity?: RiskSeverityEnum;
    /**
     * Current status of the risk
     * 
     * * `ACTIVE` - Active
     * * `MITIGATED` - Mitigated
     * * `RESOLVED` - Resolved
     * @type {RiskStatusEnum}
     * @memberof Risk
     */
    status?: RiskStatusEnum;
    /**
     * Associated VIP profile
     * @type {number}
     * @memberof Risk
     */
    profile: number;
    /**
     * 
     * @type {string}
     * @memberof Risk
     */
    readonly profileName: string;
    /**
     * Source of the risk information
     * @type {string}
     * @memberof Risk
     */
    source?: string;
    /**
     * Steps taken to mitigate the risk
     * @type {string}
     * @memberof Risk
     */
    mitigation?: string;
    /**
     * URL link to the news article
     * @type {string}
     * @memberof Risk
     */
    link?: string | null;
    /**
     * Domain of the article source
     * @type {string}
     * @memberof Risk
     */
    domain?: string | null;
    /**
     * Displayed URL for the article
     * @type {string}
     * @memberof Risk
     */
    displayedLink?: string | null;
    /**
     * Short excerpt from the article
     * @type {string}
     * @memberof Risk
     */
    snippet?: string | null;
    /**
     * List of highlighted words in the snippet
     * @type {any}
     * @memberof Risk
     */
    snippetHighlightedWords?: any | null;
    /**
     * Base64 encoded favicon of the source website
     * @type {string}
     * @memberof Risk
     */
    favicon?: string | null;
    /**
     * Base64 encoded thumbnail image for the article
     * @type {string}
     * @memberof Risk
     */
    thumbnail?: string | null;
    /**
     * Original publication date of the news article or content
     * @type {string}
     * @memberof Risk
     */
    publishDate?: string | null;
    /**
     * When the risk was created
     * @type {Date}
     * @memberof Risk
     */
    readonly createdAt: Date;
    /**
     * When the risk was last updated
     * @type {Date}
     * @memberof Risk
     */
    readonly updatedAt: Date;
    /**
     * Type of the risk
     * @type {string}
     * @memberof Risk
     */
    type?: string | null;
}



/**
 * Check if a given object implements the Risk interface.
 */
export function instanceOfRisk(value: object): value is Risk {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('profile' in value) || value['profile'] === undefined) return false;
    if (!('profileName' in value) || value['profileName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function RiskFromJSON(json: any): Risk {
    return RiskFromJSONTyped(json, false);
}

export function RiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): Risk {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'description': json['description'],
        'severity': json['severity'] == null ? undefined : RiskSeverityEnumFromJSON(json['severity']),
        'status': json['status'] == null ? undefined : RiskStatusEnumFromJSON(json['status']),
        'profile': json['profile'],
        'profileName': json['profile_name'],
        'source': json['source'] == null ? undefined : json['source'],
        'mitigation': json['mitigation'] == null ? undefined : json['mitigation'],
        'link': json['link'] == null ? undefined : json['link'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'displayedLink': json['displayed_link'] == null ? undefined : json['displayed_link'],
        'snippet': json['snippet'] == null ? undefined : json['snippet'],
        'snippetHighlightedWords': json['snippet_highlighted_words'] == null ? undefined : json['snippet_highlighted_words'],
        'favicon': json['favicon'] == null ? undefined : json['favicon'],
        'thumbnail': json['thumbnail'] == null ? undefined : json['thumbnail'],
        'publishDate': json['publish_date'] == null ? undefined : json['publish_date'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'type': json['type'] == null ? undefined : json['type'],
    };
}

  export function RiskToJSON(json: any): Risk {
      return RiskToJSONTyped(json, false);
  }

  export function RiskToJSONTyped(value?: Omit<Risk, 'id'|'profile_name'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'severity': RiskSeverityEnumToJSON(value['severity']),
        'status': RiskStatusEnumToJSON(value['status']),
        'profile': value['profile'],
        'source': value['source'],
        'mitigation': value['mitigation'],
        'link': value['link'],
        'domain': value['domain'],
        'displayed_link': value['displayedLink'],
        'snippet': value['snippet'],
        'snippet_highlighted_words': value['snippetHighlightedWords'],
        'favicon': value['favicon'],
        'thumbnail': value['thumbnail'],
        'publish_date': value['publishDate'],
        'type': value['type'],
    };
}

